import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { IconButton, Typogaphy } from 'vnetwork-ui'
import TextEditorCustomize from '@/components/TextEditorCustomize'
import HelpIcons from '@/icons/HelpIcons'
import { useAppStore } from '@/stores/useAppStore'
import contents from '@/modules/Ticket/help/ticket-root-cause-help.md'
import { useTranslation } from 'react-i18next'
interface Props {
    control: Control<any>
    viewOnly?: boolean
}

const TicketRootCause: React.FC<Props> = ({ control, viewOnly = false }) => {
    const { t } = useTranslation()
    const { setIsShowHelp, setHelpContent, isShowHelp } = useAppStore()
    return (
        <div>
            <div className="flex items-center mb-1">
                <Typogaphy size="small" className="mb-1">
                    {t('ticket-root-cause')}
                </Typogaphy>
                <IconButton
                    size="small"
                    className="mb-1"
                    onClick={() => {
                        setIsShowHelp(!isShowHelp)
                        setHelpContent(contents)
                    }}
                >
                    <HelpIcons className="text-black" />
                </IconButton>
            </div>
            <Controller
                control={control}
                name="ticket_root_cause"
                render={({ field, fieldState: { error } }) => {
                    const message =
                        error &&
                        typeof error === 'object' &&
                        'text' in (error as any)
                            ? (error as any).text?.message
                            : undefined

                    return (
                        <div>
                            <TextEditorCustomize
                                disabled={viewOnly}
                                disabledAttachments={true}
                                value={
                                    typeof field.value === 'string'
                                        ? { text: field.value, attachments: [] }
                                        : field.value || {
                                              text: '',
                                              attachments: [],
                                          }
                                }
                                onChange={(val) => field.onChange(val)}
                                imagePrefix="tickets"
                            />
                            {message && (
                                <p className="text-red-500 text-sm mt-1">
                                    {message}
                                </p>
                            )}
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default TicketRootCause
